import React, { FC } from "react"

import { ImageType } from "@srcTypes"
import { generateConditionalClassName } from "@utils"

import Avatar, { AVATAR_SIZES } from "../Avatar/Avatar"

import "./AvatarWithName.scss"

type AvatarWithNameProps = {
  bio?: string,
  image?: ImageType,
  name: string,
  size?: Exclude<AVATAR_SIZES, "XL">,
}

const AvatarWithName: FC<AvatarWithNameProps> = ({
  bio,
  image,
  name,
  size = AVATAR_SIZES.M,
}) => (
  <div className={`AvatarWithName size--${size}`}>
    {image && (
      <Avatar
        name={name}
        image={image}
        size={size}
      />
    )}
    <div className={bio ? "has-bio" : ""}>
      <h6
        className={generateConditionalClassName({
          "type--headline-semibold-M": size === AVATAR_SIZES.L,
          "type--headline-semibold-S": size === AVATAR_SIZES.M,
          "type--headline-semibold-XS": size === AVATAR_SIZES.S,
        })}
      >
        {name}
      </h6>
      {bio && (
        <p
          className={generateConditionalClassName({
            "color--text-light": true,
            "font-family--mono": true,
            "font-weight--light": true,
            "line-height--relaxed": true
          })}
        >
          {bio}
        </p>
      )}
    </div>
  </div>
)

export default AvatarWithName
